var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 226.485,
    height: 207.637,
    viewBox: "0 0 226.485 207.637",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:url(#b);}.c{opacity:0.7;}.d{fill:url(#c);}.e{fill:#3ad29f;}.f{fill:#4d8af0;}.f,.g,.h,.i{opacity:0.5;}.g{fill:#f55f44;}.h,.j{fill:#47e6b1;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#007392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.718,
    stopColor: "#003b59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003a58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#007392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003a58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-590.455 -277.182)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-8663-2843a75.525,75.525,0,0,1-29.582-5.973,76,76,0,0,1-12.91-7.007,76.548,76.548,0,0,1-11.248-9.281,76.6,76.6,0,0,1-9.28-11.248,76.031,76.031,0,0,1-7.008-12.91A75.533,75.533,0,0,1-8739-2919a75.533,75.533,0,0,1,5.973-29.583,76.063,76.063,0,0,1,7.008-12.91,76.6,76.6,0,0,1,9.28-11.248,76.548,76.548,0,0,1,11.248-9.281,76,76,0,0,1,12.91-7.007A75.525,75.525,0,0,1-8663-2995c.88,0,1.771.015,2.646.045L-8662.437-2843H-8663Z",
    transform: "translate(6746.878 7240.429) rotate(30)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-8663-2995a76,76,0,0,1,76,76,76,76,0,0,1-76,76Z",
    transform: "translate(6746.878 7240.429) rotate(30)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(590.45 287.721)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(77.623 64.838)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M354.01,321.765l21.814,20,27.042-39.011,10.907,9.09-37.949,48.1-30.9-34.54Z",
    transform: "translate(-344.921 -302.75)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M368.294,322.4l17.7,16.221,25.069-36.866,8.848,7.373L385.99,353.363l-25.069-28.018Z",
    transform: "translate(-276.433 -237.341)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M326.542,109.054a.968.968,0,0,1-.54-1.17.467.467,0,0,0,.021-.107h0a.486.486,0,0,0-.872-.322h0a.465.465,0,0,0-.054.1.968.968,0,0,1-1.17.54.466.466,0,0,0-.107-.021h0a.486.486,0,0,0-.322.872h0a.465.465,0,0,0,.1.054.968.968,0,0,1,.54,1.17.464.464,0,0,0-.021.107h0a.486.486,0,0,0,.872.322h0a.466.466,0,0,0,.054-.1.968.968,0,0,1,1.17-.54.465.465,0,0,0,.107.021h0a.486.486,0,0,0,.322-.872h0A.465.465,0,0,0,326.542,109.054Z",
    transform: "translate(-282.979 -96.415)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M180.542,434.054a.968.968,0,0,1-.54-1.17.466.466,0,0,0,.021-.107h0a.486.486,0,0,0-.872-.322h0a.466.466,0,0,0-.054.1.968.968,0,0,1-1.17.54.467.467,0,0,0-.107-.021h0a.486.486,0,0,0-.322.872h0a.466.466,0,0,0,.1.054.968.968,0,0,1,.54,1.17.466.466,0,0,0-.021.107h0a.486.486,0,0,0,.872.322h0a.465.465,0,0,0,.054-.1.968.968,0,0,1,1.17-.54.465.465,0,0,0,.107.021h0a.486.486,0,0,0,.322-.872h0A.465.465,0,0,0,180.542,434.054Z",
    transform: "translate(-175.456 -335.765)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.581,
    cy: 1.581,
    r: 1.581,
    transform: "translate(195.655 65.358)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.581,
    cy: 1.581,
    r: 1.581,
    transform: "translate(30.415 178.416)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 1.581,
    cy: 1.581,
    r: 1.581,
    transform: "translate(222.536 126.236)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M865.543,138.054a.968.968,0,0,1-.54-1.17.467.467,0,0,0,.021-.107h0a.486.486,0,0,0-.872-.322h0a.462.462,0,0,0-.054.1.968.968,0,0,1-1.17.54.465.465,0,0,0-.107-.021h0a.486.486,0,0,0-.322.872h0a.466.466,0,0,0,.1.054.968.968,0,0,1,.54,1.17.464.464,0,0,0-.021.107h0a.486.486,0,0,0,.872.322h0a.468.468,0,0,0,.054-.1.968.968,0,0,1,1.17-.54.466.466,0,0,0,.107.021h0a.486.486,0,0,0,.322-.872h0A.465.465,0,0,0,865.543,138.054Z",
    transform: "translate(-679.931 -117.773)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M965.543,766.054a.968.968,0,0,1-.54-1.17.463.463,0,0,0,.021-.107h0a.486.486,0,0,0-.872-.322h0a.467.467,0,0,0-.054.1.968.968,0,0,1-1.17.54.463.463,0,0,0-.107-.021h0a.486.486,0,0,0-.322.872h0a.468.468,0,0,0,.1.054.968.968,0,0,1,.54,1.17.463.463,0,0,0-.021.107h0a.486.486,0,0,0,.872.322h0a.461.461,0,0,0,.054-.1.968.968,0,0,1,1.17-.54.464.464,0,0,0,.107.021h0a.486.486,0,0,0,.322-.872h0A.467.467,0,0,0,965.543,766.054Z",
    transform: "translate(-753.577 -580.27)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M173.542,244.054a.968.968,0,0,1-.54-1.17.466.466,0,0,0,.021-.107h0a.486.486,0,0,0-.872-.322h0a.465.465,0,0,0-.054.1.968.968,0,0,1-1.17.54.465.465,0,0,0-.107-.021h0a.486.486,0,0,0-.322.872h0a.466.466,0,0,0,.1.054.968.968,0,0,1,.54,1.17.465.465,0,0,0-.021.107h0a.486.486,0,0,0,.872.322h0a.466.466,0,0,0,.054-.1.968.968,0,0,1,1.17-.54.466.466,0,0,0,.107.021h0a.486.486,0,0,0,.322-.872h0A.466.466,0,0,0,173.542,244.054Z",
    transform: "translate(-170.3 -195.838)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 1.581,
    cy: 1.581,
    r: 1.581,
    transform: "translate(19.347 73.264)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 1.581,
    cy: 1.581,
    r: 1.581,
    transform: "translate(223.327 85.914)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "translate(151.907)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 0.791,
    height: 4.48,
    transform: "translate(1.845)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 0.791,
    height: 4.48,
    transform: "translate(4.48 1.845) rotate(90)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "translate(154.806 175.518)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 0.791,
    height: 4.48,
    transform: "translate(1.845)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 0.791,
    height: 4.48,
    transform: "translate(4.48 1.845) rotate(90)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "translate(5.116 185.005)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 0.791,
    height: 4.48,
    transform: "translate(1.845)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 0.791,
    height: 4.48,
    transform: "translate(4.48 1.845) rotate(90)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "translate(195.113 108.362)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 0.791,
    height: 4.48,
    transform: "translate(1.845)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 0.791,
    height: 4.48,
    transform: "translate(4.48 1.845) rotate(90)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M793.629,117.481l1.7,1.556,2.406-3.538.849.708-3.255,4.245-2.406-2.689Z",
    transform: "translate(-583.951 -85.061)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.d91f49de6cc1e23dceeb9cf98ca72b03.svg";
export { ForwardRef as ReactComponent };